import { GET_PARCHI_HOST } from "apis";
import { serializeErrorForTracking, track } from "../../utils/tracking";
import fetchWrapper from "apis/src/fetch-client";

async function uploadReceiptBlobV2({
  file,
  fileName,
}: {
  file: Blob;
  fileName: string;
}): Promise<{
  success: boolean;
  url?: string;
}> {
  try {
    const formData = new FormData();
    formData.append("pdf", file, "document.pdf");
    formData.append("type", "receipt");
    formData.append("fileName", fileName);
    const requestOptions: RequestInit = {
      method: "POST",
      body: formData,
      redirect: "follow",
      mode: "cors",
      credentials: "include",
    };

    const response = await fetchWrapper(
      `${GET_PARCHI_HOST()}/service/v2/pdf-upload`,
      requestOptions
    );
    return await response.json();
  } catch (error: any) {
    track(`S3_UPLOAD_FAILED_LOCAL_RECEIPT_FLOW`, {
      on: "uploadReceiptBlobV2",
      what: serializeErrorForTracking(error),
      stack: error?.stack,
      fileName: fileName
    });
    console.error(error);
    return {
      success: false,
    };
  }
}

export default uploadReceiptBlobV2;
